import { useEffect, useState } from 'react';

import { getWechatInfo } from '@/api/customer';
import { MethodEnum } from '@/components/common/SharePopup/types';
import shareWechat from '@/components/common/SharePopup/js/wechat';
import { addParameterToUrl, isWeixinBrowser } from '@/utils/tool';
import loadWechatSdk from '@/utils/wechat';

export interface ShareItemInterface {
  description: string;
  language: string;
  link_url?: string;
  title: string;
  share_img_url: string;
  loading?: boolean;
}

export default function useAutoSetInfoinWechat(data) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (isWeixinBrowser() && isReady) {
      const shareInfo = {
        title: data?.title,
        desc: data?.description || data?.title,
        link: data?.link_url || window.location.href,
        imgUrl: data?.share_img_url
      };
      shareWechat(
        { ...shareInfo, link: addParameterToUrl(shareInfo.link, 'utm_source', MethodEnum.WeChatMoments) },
        MethodEnum.WeChatMoments
      );
      shareWechat(
        { ...shareInfo, link: addParameterToUrl(shareInfo.link, 'utm_source', MethodEnum.WeChatSession) },
        MethodEnum.WeChatSession
      );
    }
  }, [data?.loading, JSON.stringify(data), isReady]);

  const handleWechatReady = (count: number) => {
    Promise.all([
      getWechatInfo({ url: window.location.href })
        .then(({ object }) => {
          return object;
        })
        .catch(() => null),
      loadWechatSdk()
        .then(() => true)
        .catch(() => false)
    ]).then(([wxInfo, loadResult]) => {
      if (!wxInfo || !loadResult) {
        if (count < 5) {
          handleWechatReady(count + 1);
        }
        return;
      }
      !!window.wx &&
        !!window.wx.config &&
        window.wx.config({
          debug: false,
          appId: wxInfo.appId,
          timestamp: wxInfo.timestamp || 0,
          nonceStr: wxInfo.nonceStr,
          signature: wxInfo.signature,
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'openAddress'
          ]
        });
      !!window.wx &&
        !!window.wx.ready &&
        window.wx.ready(() => {
          setIsReady(true);
        });
    });
  };

  useEffect(() => {
    if (isWeixinBrowser() && !isReady) {
      handleWechatReady(1);
    }
  }, [isReady]);
}
